export var TaxStatus;
(function (TaxStatus) {
    /**
     * Determining if 19% taxes (Mwst) applies
     */
    TaxStatus["TAXING"] = "TAXING";
    /**
     * No taxes apply (mwst).
     */
    TaxStatus["NOT_TAXING"] = "NOT_TAXING";
})(TaxStatus || (TaxStatus = {}));
//# sourceMappingURL=tax-status.enum.js.map